<template>
    <span v-if="getTitle()" :class="'badge badge-pill sammio__badge badge-primary sammio-pill--' + vocabularyClass">
        <span class="sr-only">{{ $t('sammio.filter') }}: </span>
        <span>{{ getTitle() }}</span>
        <span 
            tabindex="0"
            @click="removeFilter()"
            @keydown.enter="removeFilter()"
            class="ml-2"
        >
            <x-icon role="presentation" size="1.25x"></x-icon>
            <span class="sr-only">{{ $t('sammio.remove_filter') }} {{ getTitle() }}</span>
        </span>
    </span>

</template>

<script>
    import {XIcon} from 'vue-feather-icons'
    import {mapGetters} from "vuex";
    import { i18n } from "../../translations/i18n"
    export default {
        name: "SammioActiveFilter",

        props: [ 'categoryId' ],
        components: {
            XIcon
        },
        methods: {
            getTitle() {
                let labels = this.$store.getters.getFilterLabels
                if (labels.hasOwnProperty(this.categoryId) && labels[this.categoryId] !== '') {
                    return labels[this.categoryId]
                }
                return ''
            },
            removeFilter(title) {
                this.$store.dispatch('deactivateFilter', this.categoryId)
                this.$store.dispatch('setSearchCurrentPage', {page: 1})
                const removalAnnouncerText = i18n.t('sammio.removed') + i18n.t('sammio.filter') + ': ' + this.getTitle();
                jQuery('#announcer').text(removalAnnouncerText);
            }
        },
        computed: {
            ...mapGetters({
                filterVocabularies: 'getFilterVocabularies'
            }),
            vocabularyClass() {
                if (this.filterVocabularies.hasOwnProperty(this.categoryId)) {
                    return this.filterVocabularies[this.categoryId]
                }
                return ''
            }
        }

    }
</script>

<style lang="scss">

</style>
